module.exports = global["Modernizr"] = require("-!/builds/fe/kefu-webim/node_modules/i18next-loader/index.js?{\"quotes\":\"\\\"\"}!./modernizr.js");


//////////////////
// WEBPACK FOOTER
// ./src/js/app/libs/modernizr.js
// module id = 9
// module chunks = 0